import React from "react";
import { Box, Text, Flex, Image, Button } from "@chakra-ui/react";
import { ActiveLinkProvider } from "./ActiveLinkContext";
import Header from "../components/Header";
import { useNavigate } from "react-router-dom";

import img from "../images/about.jpeg";
import acrylic from "../images/acrylic.png";
import gelbuild from "../images/gelbuilder.png";
import gelx from "../images/gel-x.png";
import dip from "../images/dip.png";
import deluxe from "../images/deluxe.png";
import bubble from "../images/bubblespa.png";
import detox from "../images/detox.png";
import express from "../images/express.png";

const maniPediServices = [
  {
    title: "Acrylic Set",
    description:
      "This set applies a mixture of liquid monomer and powder polymer to strengthen and extend natural nails or tips. This durable and long-lasting manicure can be customized in various shapes, lengths, and designs, perfect for those seeking strong, beautiful nails.",
    image: acrylic,
    price: "$50+",
  },
  {
    title: "Gel Builder Set",
    description:
      "Our gel builder set uses long-lasting gel to add strength to nails and enhance them for natural-looking nails. It is super convenient for busy people who require a longer lasting shine without chipping or fading. ",
    image: gelbuild,
    price: "$60+",
  },
  {
    title: "Gel-X Tip Extensions",
    description:
      "Gel X is a soft gel tip cured with gel base onto your natural nail to provide length. This service is chemical free and icnludes cuticle care along with a gel polish of your choice.",
    image: gelx,
    price: "$80+",
  },
  {
    title: "Gel Dipping Powder Set",
    description:
      "This is our healthier alternative to more traditional methods recommended for more weak and fragile nails. We use a powder dip with added Vitamin E and Calcium which is both durable and lightweight, giving a natural feel and look to your nails. ",
    image: dip,
    price: "$60+",
  },
  {
    title: "Deluxe Pedicure",
    description:
      "This pedi is designed for you to admire your feet after intensive toenail, cuticle, and sole maintenance. You will enjoy a hydrating foot treatment to make your soles feel brand new. This pedicure comes with a relaxing 15-minute massage of your arms, hands and legs to relieve the everyday stress and tension, giving you a peaceful and relaxing experience, along with foot scrubs and a hydrating foot mask.",
    image: deluxe,
    price: "$80",
  },
  {
    title: "Bubble Spa Pedicure",
    description:
      "Enjoy our new 5-in-1 Collagen Bubble Spa Pedi! Pick any color you like and then enjoy the collagen infused bubbles that soften your feet! Includes 10 minute leg and foot massage, sugar scrub, hydrating foot mask, callus treatment, and hot towels!",
    image: bubble,
    price: "$68",
  },
  {
    title: "Basic Pedi Detox",
    description:
      "The Basic Pedi Detox begins with a soak in our new herbal Himalayan salt. Our foot detox helps relieve muscle aches and dry skin while softening the cuticles and calluses. Enjoy an all natural way to detox the body and take care of your feet with our basic pedi. Includes a 5 minute massage and a hot towel.",
    image: detox,
    price: "$50",
  },
  {
    title: "Express Pedicure",
    description:
      "Ideal for our clients who need a quick pedi on the go during rush hour. This pedicure offers a sugar scrub along with toenail and cuticle care.",
    image: express,
    price: "$40",
  },
];

function ManiPediInfo() {
  const navigate = useNavigate();

  return (
    <ActiveLinkProvider>
      <Header />
      <Box
        height={{ base: "40vh", md: "60vh" }}
        position="relative"
        backgroundPosition="center"
        backgroundRepeat="no-repeat"
        backgroundSize="cover"
        backgroundImage={img}
      ></Box>

      {/* Main content container */}
      <Box
        padding={{ base: 4, md: 8 }}
        bg={
          "linear-gradient(179.4deg, rgb(253, 240, 233) 2.2%, rgb(255, 194, 203) 96.2%)"
        }
      >
        <Text
          fontSize={{ base: "2xl", md: "4xl" }}
          fontWeight="bold"
          color="pink.600"
          textAlign="center"
          mb={8}
          fontFamily={["Dancing Script", "cursive"]}
        >
          Manicure & Pedicure Services
        </Text>

        {/* Services container */}
        <Flex wrap="wrap" justify="center" gap={8}>
          {maniPediServices.map((service, index) => (
            <Box
              key={index}
              width={{ base: "100%", md: "45%" }}
              borderWidth="1px"
              borderRadius="lg"
              overflow="hidden"
              boxShadow="lg"
              bg="white"
              padding={6}
              mb={8}
            >
              {/* Service Image */}
              <Image
                src={service.image}
                alt={service.title}
                borderRadius="md"
                height="200px"
                width="100%"
                objectFit="cover"
                mb={4}
              />

              {/* Service Title */}
              <Text
                fontSize={{ base: "xl", md: "2xl" }}
                fontWeight="bold"
                color="pink.500"
                mb={2}
                fontFamily={["Dancing Script", "cursive"]}
              >
                {service.title}
              </Text>

              {/* Service Description */}
              <Text fontSize={{ base: "md", md: "lg" }} mb={4}>
                {service.description}
              </Text>

              {/* Service Price */}
              <Text
                fontSize={{ base: "lg", md: "xl" }}
                fontWeight="bold"
                mb={4}
              >
                {service.price}
              </Text>

              {/* Book Now Button */}
              <Button
                bg={"pink.300"}
                variant="solid"
                size="md"
                width="30%"
                _hover={{ bg: "pink.500" }}
                onClick={() => {
                  navigate("/contact");
                }}
              >
                Book Now
              </Button>
            </Box>
          ))}
        </Flex>
      </Box>
    </ActiveLinkProvider>
  );
}

export default ManiPediInfo;
